import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72c7956f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "borrow-applyDetail" }
const _hoisted_2 = { class: "borrow-tips" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "借款金额：", -1))
const _hoisted_4 = { class: "money" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e87e04"} }, "注：若借款金额超过5万元，需集团总经理审批", -1))
const _hoisted_6 = { class: "sign-table-wrapper" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { borrowApplyDetail } from "@/api/process";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }

const BorrowAmount = ref<number>(0);




watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

onMounted(async () => {
  getdata();
});

const getdata = async () => {
  const { Data } = await borrowApplyDetail({
    Id: props.folwId,
  });
  BorrowAmount.value = Data?.PageData.BorrowAmount || 0;
  tableData.value = Data?.PageFiles || [];
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "个人借款申请",
      style: {"margin-top":"24px"}
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(BorrowAmount.value) + "元", 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})